export const KpiLineChartSkeleton = () => {
  return (
    <svg
      className="animate-pulse mt-4"
      width="170"
      height="37"
      viewBox="0 0 170 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 36C1.66508 35.6026 9.00619 26.1517 15.3832 17.5195C18.9603 12.6773 25.9757 11.8465 30.4725 15.8491L37.6778 22.2627C40.863 25.0979 45.4957 25.6013 49.2155 23.5166L59.853 17.5549C62.4769 16.0843 65.6235 15.873 68.4206 16.9796L79.3922 21.32C82.8414 22.6845 86.7625 22.0277 89.5788 19.6138L102.016 8.95345C104.511 6.81505 107.897 6.0387 111.074 6.87664L123.232 10.083C125.655 10.7222 128.23 10.428 130.447 9.25864L141.747 3.29844C145.495 1.32156 150.081 1.92132 153.195 4.79537L169 19.3846"
        stroke="#E4E3E7"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
